export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-[520px] md:min-h-[620px] flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-accent-100/40 via-background-50 to-primary-100/30"></div>

      <div className="relative w-full px-4 md:px-6 lg:px-8 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16 w-full">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 text-accent-800 text-xs font-medium mb-4">
              <i className="ri-fire-line text-sm"></i>
              <span>韩漫追更 韩漫最新更新</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              韩漫屋 · 韩漫追更 韩漫最新更新平台
            </h1>

            <p className="mt-3 text-lg md:text-xl text-foreground-600 font-heading">
              韩漫连载更新 韩漫更新提醒 · 追更平台首选
            </p>

            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              韩漫屋专注韩漫追更服务，实时追踪韩漫最新更新动态，覆盖恋爱、奇幻、穿越、复仇、校园等热门题材。
              每日自动抓取韩漫连载更新信息，第一时间推送最新章节提醒，让热爱韩漫的你不再错过任何精彩章节。
              本站完全免费追更，无需注册即可浏览最新章节更新列表，是韩漫爱好者最值得信赖的追更平台。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mt-6">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-book-open-line text-primary-600 text-sm"></i>
                </div>
                <div className="text-left">
                  <span className="block text-lg font-bold text-foreground-900">2000+</span>
                  <span className="text-xs text-foreground-500">部韩漫追踪</span>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-time-line text-accent-600 text-sm"></i>
                </div>
                <div className="text-left">
                  <span className="block text-lg font-bold text-foreground-900">每日更新</span>
                  <span className="text-xs text-foreground-500">实时追更提醒</span>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-shield-check-line text-secondary-600 text-sm"></i>
                </div>
                <div className="text-left">
                  <span className="block text-lg font-bold text-foreground-900">完全免费</span>
                  <span className="text-xs text-foreground-500">无需注册登录</span>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-7">
              <a
                href="#updates"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer no-underline"
              >
                <i className="ri-flashlight-line"></i>
                查看最新更新
              </a>
              <a
                href="#features"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-secondary-300 text-foreground-700 font-medium text-sm hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer no-underline"
              >
                <i className="ri-star-line"></i>
                了解追更优势
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative w-full aspect-[4/3] lg:aspect-[5/4] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20digital%20illustration%20of%20a%20young%20woman%20reading%20Korean%20webtoons%20on%20a%20tablet%20in%20a%20cozy%20cafe%2C%20warm%20ambient%20lighting%2C%20modern%20interior%20with%20plants%2C%20vertical%20scrolling%20comics%20visible%20on%20screen%2C%20soft%20coral%20and%20cream%20color%20palette%2C%20artistic%20editorial%20composition%2C%20high%20detail%2C%20harmonious%20atmosphere%2C%20manga%20style%20background%20elements&width=700&height=560&seq=hero-main-01&orientation=landscape"
                alt="韩漫屋 - 韩漫追更平台主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}